import { mapToCanActivate, Routes } from '@angular/router'
import { MsalGuard } from '@azure/msal-angular'
import {
   CustomerServiceShellComponent
} from '@appCustomerService/containers'
import {
   AccountDetailComponent,
   AccountSearchComponent,
} from '@appCustomerService/components'
import { AccountDetailStore } from '@appCustomerService/components/account-detail/account-detail.store'
import { ComponentType_ } from '@appShared/services/lookup/[CodeGen]'
import { AuthGuardCustomerCareService, CanActivateGuardService } from '@appShared/services'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

const contentRoutes = SITE_DIRECTORY_ROUTES.customerService

const childAccountRoutes: Routes = [
   {
      path: '',
      component: AccountSearchComponent,
   },
   {
      path: `${contentRoutes.subscription.baseUri}/:id`,
      component: AccountDetailComponent,
      providers: [AccountDetailStore]
   }
   //{
   //   path: `${contentRoutes.learningJourneys.baseUri}/:parentContainerId/:title`,
   //   component: CourseLibraryComponent,
   //   data: {
   //      componentTypeCode: ComponentType_.CourseLibrary
   //   }
   //},
   //{
   //   path: `${contentRoutes.learningJourneys.baseUri}/:parentContainerId`,
   //   component: CourseLibraryComponent,
   //   data: {
   //      componentTypeCode: ComponentType_.CourseLibrary
   //   }
   //},
   //{
   //   path: contentRoutes.learningJourneys.baseUri,
   //   component: LearningJourneysComponent
   //}
]

export const CUSTOMER_SERVICE_ROUTES: Routes = [
   {
      path: contentRoutes.baseUri, /* If not lazy-loading contentRoutes.baseUri, else '' */
      component: CustomerServiceShellComponent,
      canActivate: [CanActivateGuardService, MsalGuard, AuthGuardCustomerCareService], /* remove if lazy-loading */
      children: childAccountRoutes
   }
]
